import Head from "next/head";

const JobPosting = ({ jobs }) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // Adding 1 to get month in 1-12 format
  const date = "01";

  const formattedDate = new Date(
    `${year}-${month.toString().padStart(2, "0")}-${date}T00:00:00.000Z`
  );

  jobs = jobs.map((job, i) => {
    const jobPosts = {
      company: {
        name: "Sparkle Infotech",
        website: process.env.NEXT_PUBLIC_SERVER_URL.concat("/careers"),
        logo: process.env.NEXT_PUBLIC_SERVER_URL.concat(
          "/uploads/logo_1_7fcebbad0d.webp"
        ),
      },
      address: {
        streetAddress:
          "306 - Rajhans Complex 2, Near Nirmal Hospital, Ring Road",
        city: "Surat",
        state: "Gujarat",
        zipCode: 395003,
        country: "India",
      },
    };
    const structuredData = {
      "@context": "https://schema.org/",
      "@type": "JobPosting",
      datePosted: formattedDate,
      description: `available openings for ${job.attributes.Developer} is ${job.attributes.Vacancies} `,
      employmentType: job.employmentType,
      hiringOrganization: {
        "@type": "Organization",
        name: jobPosts.company.name,
        sameAs: jobPosts.company.website,
        logo: {
          "@type": "ImageObject",
          url: jobPosts.company.logo,
          width: 56,
          height: 56,
        },
      },
      jobLocation: {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          streetAddress: jobPosts.address.streetAddress,
          addressLocality: jobPosts.address.city,
          addressRegion: jobPosts.address.state,
          postalCode: jobPosts.address.zipCode,
          addressCountry: jobPosts.address.country,
        },
      },
      title: job.attributes.Developer,
      validThrough: jobPosts.validThrough,
    };

    return {
      ...structuredData,
    };
  });

  return (
    <Head>
      <script type="application/ld+json">{JSON.stringify(jobs)}</script>
    </Head>
  );
};

export default JobPosting;
